const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_57d85e2a-e3d9-489b-aea5-c3202d03fe13/artifacts/xzltz4c8_ChatGPT%20Image%208%20de%20mai.%20de%202026%2C%2018_11_09.png";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="border-t border-white/5 bg-[#050505] py-16"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-10">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
                    <div className="md:col-span-5">
                        <div className="flex items-center gap-3 mb-6">
                            <img
                                src={LOGO_URL}
                                alt="FLUXO NAS VENDAS"
                                className="h-10 w-10 object-contain"
                            />
                            <div className="leading-none">
                                <div className="text-[10px] tag-fluxo">FLUXO</div>
                                <div className="text-[11px] text-white/80 tracking-[0.32em] font-medium font-['Outfit']">
                                    NAS VENDAS
                                </div>
                            </div>
                        </div>
                        <p className="text-white/40 text-sm leading-relaxed max-w-sm">
                            Estrutura privada de aquisição e fechamento comercial.
                            Só ganhamos quando você ganha.
                        </p>
                    </div>

                    <div className="md:col-span-3">
                        <div className="label-fluxo mb-5">Contato</div>
                        <ul className="space-y-3 text-sm text-white/55">
                            <li>contato@fluxonasvendas.com.br</li>
                            <li>@fluxonasvendas</li>
                            <li>facebook.com/fluxonasvendas</li>
                        </ul>
                    </div>

                    <div className="md:col-span-4">
                        <div className="label-fluxo mb-5">Operação</div>
                        <ul className="space-y-3 text-sm text-white/55">
                            <li>Florianópolis — Brasil</li>
                            <li>Atendimento sob agendamento</li>
                            <li>Capacidade limitada por ciclo</li>
                        </ul>
                    </div>
                </div>

                <div className="mt-14 pt-8 border-t border-white/5 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
                    <div className="text-white/30 text-xs tracking-[0.2em] uppercase font-['Outfit']">
                        © {new Date().getFullYear()} FLUXO NAS VENDAS · Todos os direitos reservados
                    </div>
                    <div className="flex items-center gap-6 text-white/30 text-xs tracking-[0.2em] uppercase font-['Outfit']">
                        <a href="/admin" data-testid="footer-admin" className="hover:text-[#d4af37] transition-colors">
                            Acesso restrito
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
}
